import { light } from "@material-ui/core/styles/createPalette";
import React from "react";
import GitHubCalendar from 'react-github-calendar';
export const Github = () => {
  const colourTheme = {
    background: "transparent",
    text: "#ffffff",
    grade4: "#8400b8",
    grade3: "#b22ff4",
    grade2: "#b265f6",
    grade1: "#c084f5",
    grade0: "#ecd9fc",
    light: ['#f0f0f0', '#afe88e','#66eb1e', '#08bf2f',  '#089c3e'],
    dark: ['#383838', '#4D455D', '#7DB9B6', '#F5E9CF','#E96479'],
    
  };
  // const [{ themename }] = React.useContext(ThemeContext);

  return (
    <>
    {/* + colourTheme */}
      <div className={"section " } >
        <h2 className="section__title different">
          Days I <span className="different"> Code</span>
        </h2>
        <GitHubCalendar
          username="suvranilg"
          blockSize={15}
          blockMargin={5}
          theme={colourTheme }
          colorScheme={"light"}
          fontSize={16}
          // hideTotalCount="false"
        />
      </div>
    </>
  );
};
